import { StoreAction, XmAction } from 'store/actions';
import { SaveTmoAddress, WatchesActivationRequest, WatchesActivationStatus, WatchesAddress, WatchesAddressValidation, WatchesPairEligibility, WatchesPairEligibilityRequestId } from './models';

export function watchesAddressValidationReducer(state: WatchesAddressValidation, action: XmAction<WatchesAddressValidation>): WatchesAddressValidation {
    switch (action.type) {
        case StoreAction.GET_WATCH_ADDRESS_VALIDATION:
            return action.payload;
        default:
            return state;
    }
}

export function watchesAddressReducer(state: WatchesAddress, action: XmAction<WatchesAddress>): WatchesAddress {
    switch (action.type) {
        case StoreAction.PERSIST_WATCH_ADDRESS:
        case StoreAction.POST_WATCH_ADDRESS:
        case StoreAction.GET_WATCH_ADDRESS:
            return action.payload;
        default:
            return state;
    }
}

export function watchesPairEligibilityRequestIdReducer(state: WatchesPairEligibilityRequestId, action: XmAction<WatchesPairEligibilityRequestId>): WatchesPairEligibilityRequestId {
    switch (action.type) {
        case StoreAction.GET_WATCH_PAIR_ELIGIBILITY_REQUESTID:
        case StoreAction.POST_STANDALONE_WATCH_PAIR_ELIGIBILITY_REQUESTID:
            return action.payload;
        default:
            return state;
    }
}

export function watchesActivationRequestReducer(state: WatchesActivationRequest, action: XmAction<WatchesActivationRequest>): WatchesActivationRequest {
    switch (action.type) {
        case StoreAction.POST_WATCH_ACTIVATION:
        case StoreAction.GET_ONGOING_ACTIVATION_REQUEST:
        case StoreAction.CONFIRM_WATCH_ACTIVATION:
        case StoreAction.STANDALONE_ACTIVATION:
            return action.payload;
        default:
            return state;
    }
}

export function watchesPairEligibilityReducer(state: WatchesPairEligibility, action: XmAction<WatchesPairEligibility>): WatchesPairEligibility {
    switch (action.type) {
        case StoreAction.GET_WATCH_PAIR_ELIGIBILITY:
        case StoreAction.GET_STANDALONE_WATCH_PAIR_ELIGIBILITY:
            return action.payload;
        default:
            return state;
    }
}

export function watchesActivationStatusReducer(state: WatchesActivationStatus, action: XmAction<WatchesActivationStatus>): WatchesActivationStatus {
    switch (action.type) {
        case StoreAction.GET_WATCH_ACTIVATION_STATUS:
            return action.payload;
        default:
            return state;
    }
}

export function watchesTmoAddressReducer(state: SaveTmoAddress, action: XmAction<SaveTmoAddress>): SaveTmoAddress {
    switch (action.type) {
        case StoreAction.POST_WATCH_TMO_ADDRESS:
            return action.payload;
        default:
            return state;
    }
}
